/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const previewRoutineChangeBodyChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineChangeBodyChangeStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineChangeBodyChangeAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const previewRoutineChangeBodyChangeRotationCountExclusiveMin = 0;
export const previewRoutineChangeBodyChangeRotationCountMax = 2147483647;

export const previewRoutineChangeBodyChangeParticipantsItemOrdinalMin = 0;
export const previewRoutineChangeBodyChangeParticipantsItemOrdinalMax = 19;

export const previewRoutineChangeBodyChangeParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const previewRoutineChangeBodyChangeParticipantsMax = 20;

export const previewRoutineChangeBodyChangeRotationChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineChangeBodyChangeEndedAtOneOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartWeekdayMax = 7;

export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin = 0;
export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax = 1439;

export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndWeekdayMax = 7;

export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin = 0;
export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax = 1439;

export const previewRoutineChangeBodyChangeSectionChangeOneSectionsItemFullWeekDefault = false;
export const previewRoutineChangeBodyChangeSectionChangeOneSectionsMax = 14;

export const previewRoutineChangeBodyChangeSectionChangeOneTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineChangeBodyChangeSectionChangeOneEffectiveLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const previewRoutineChangeBodyExpectedVersionExclusiveMin = 0;
export const previewRoutineChangeBodyExpectedVersionMax = 9007199254740991;

export const PreviewRoutineChangeBody = zod.object({
  change: zod.object({
    teamId: zod.unknown().optional(),
    scheduleId: zod.unknown().optional(),
    timeZone: zod.unknown().optional(),
    timing: zod
      .union([
        zod.object({
          mode: zod.literal('immediate'),
        }),
        zod.object({
          mode: zod.literal('cycle'),
        }),
        zod.object({
          mode: zod.literal('date'),
          localDate: zod.iso.date().regex(previewRoutineChangeBodyChangeTimingThreeLocalDateRegExp),
        }),
      ])
      .optional(),
    name: zod.string().optional(),
    startLocalDate: zod.iso
      .date()
      .regex(previewRoutineChangeBodyChangeStartLocalDateRegExp)
      .optional(),
    anchorClockLocal: zod
      .string()
      .regex(previewRoutineChangeBodyChangeAnchorClockLocalRegExp)
      .optional(),
    rotation: zod
      .object({
        unit: zod.enum(['day', 'week']),
        count: zod
          .int()
          .gt(previewRoutineChangeBodyChangeRotationCountExclusiveMin)
          .max(previewRoutineChangeBodyChangeRotationCountMax),
      })
      .optional(),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(previewRoutineChangeBodyChangeParticipantsItemOrdinalMin)
            .max(previewRoutineChangeBodyChangeParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(previewRoutineChangeBodyChangeParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(previewRoutineChangeBodyChangeParticipantsMax)
      .optional(),
    effectiveLocalDate: zod.unknown().optional(),
    rotationChange: zod
      .object({
        action: zod.enum(['set', 'revise', 'cancel']),
        timing: zod
          .union([
            zod.object({
              mode: zod.literal('immediate'),
            }),
            zod.object({
              mode: zod.literal('cycle'),
            }),
            zod.object({
              mode: zod.literal('date'),
              localDate: zod.iso
                .date()
                .regex(previewRoutineChangeBodyChangeRotationChangeTimingThreeLocalDateRegExp),
            }),
          ])
          .optional(),
        effectiveLocalDate: zod.unknown().optional(),
      })
      .optional(),
    endedAt: zod
      .union([
        zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(previewRoutineChangeBodyChangeEndedAtOneOneRegExp),
          zod.literal('now'),
        ]),
        zod.null(),
      ])
      .optional(),
    sectionChange: zod
      .union([
        zod.object({
          action: zod.enum(['set', 'revise']),
          sections: zod
            .array(
              zod.object({
                startWeekday: zod
                  .int()
                  .min(1)
                  .max(previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartWeekdayMax),
                startLocalMinute: zod
                  .int()
                  .min(
                    previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin,
                  )
                  .max(
                    previewRoutineChangeBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax,
                  ),
                endWeekday: zod
                  .int()
                  .min(1)
                  .max(previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndWeekdayMax),
                endLocalMinute: zod
                  .int()
                  .min(previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin)
                  .max(previewRoutineChangeBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax),
                fullWeek: zod
                  .boolean()
                  .default(
                    previewRoutineChangeBodyChangeSectionChangeOneSectionsItemFullWeekDefault,
                  ),
              }),
            )
            .min(1)
            .max(previewRoutineChangeBodyChangeSectionChangeOneSectionsMax),
          timing: zod
            .union([
              zod.object({
                mode: zod.literal('immediate'),
              }),
              zod.object({
                mode: zod.literal('cycle'),
              }),
              zod.object({
                mode: zod.literal('date'),
                localDate: zod.iso
                  .date()
                  .regex(previewRoutineChangeBodyChangeSectionChangeOneTimingThreeLocalDateRegExp),
              }),
            ])
            .optional(),
          effectiveLocalDate: zod.iso
            .date()
            .regex(previewRoutineChangeBodyChangeSectionChangeOneEffectiveLocalDateRegExp)
            .optional(),
        }),
        zod.object({
          action: zod.literal('cancel'),
        }),
      ])
      .optional(),
  }),
  expectedVersion: zod
    .int()
    .gt(previewRoutineChangeBodyExpectedVersionExclusiveMin)
    .max(previewRoutineChangeBodyExpectedVersionMax),
});

export type PreviewRoutineChangeBody = zod.input<typeof PreviewRoutineChangeBody>;
export type PreviewRoutineChangeBodyOutput = zod.output<typeof PreviewRoutineChangeBody>;
